import { SETTING } from "@/shared/utils/settings/constants";

const prefix = "settings/";
export const _sharedActionsConstantsSettings = {
  UPDATE_SETTINGS: prefix + "UPDATE_SETTINGS",
  UPDATE_SETTING_SUCCESS: prefix + "UPDATE_SETTING_SUCCESS",
  FETCH_GEO_IP_DATA: prefix + "FETCH_GEO_IP_DATA",
  FETCH_GEO_IP_DATA_SUCCESS: prefix + "FETCH_GEO_IP_DATA_SUCCESS",
};

export const _sharedActionsSettings = {
  updateSettings: (dataOrKey, value, saveOnServer) => {
    const data = typeof dataOrKey === "object" ? dataOrKey : { [dataOrKey]: value };

    return {
      type: _sharedActionsConstantsSettings.UPDATE_SETTINGS,
      data,
      saveOnServer,
    };
  },
  updateSettingSuccess: (data) => ({
    type: _sharedActionsConstantsSettings.UPDATE_SETTING_SUCCESS,
    data,
  }),
  fetchGeoIpData: () => ({
    type: _sharedActionsConstantsSettings.FETCH_GEO_IP_DATA,
  }),
  fetchGeoIpDataSuccess: (data) => ({
    type: _sharedActionsConstantsSettings.FETCH_GEO_IP_DATA_SUCCESS,
    data,
  }),
};
